import { useLayoutEffect } from 'react'
import { SceneErrorState, useSceneErrorStore } from '../sceneErrorStore'

const formatSceneErrorMessage = (error: unknown, context?: string) => {
  const base =
    error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error'

  if (!context) return base
  return `${context}: ${base}`
}

interface Props {
  error: unknown
  context?: string
}

const SceneErrorIndicatorFallback = ({ error, context }: Props) => {
  const setErrorMessage = useSceneErrorStore((state: SceneErrorState) => state.setErrorMessage)
  const clearErrorMessage = useSceneErrorStore((state: SceneErrorState) => state.clearErrorMessage)

  useLayoutEffect(() => {
    setErrorMessage(formatSceneErrorMessage(error, context))

    return () => clearErrorMessage()
  }, [clearErrorMessage, context, error, setErrorMessage])

  return null
}

export default SceneErrorIndicatorFallback
